module.exports = __webpack_public_path__ + "static/media/gt-america-standard-light.51e078e5.woff2";